import { GET_BANNERS, CREATE_BANNER, UPDATE_BANNER, GET_ERRORS, DEACTIVATE_BANNER } from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_BANNERS       = process.env.REACT_APP_API_URL + services.getAllBanners;
const URL_CREATE_BANNER     = process.env.REACT_APP_API_URL + services.postMultipleSkuesProduct;
const URL_UPDATE_BANNER     = process.env.REACT_APP_API_URL + services.updateBanner;
const URL_DEACTIVATE_BANNER = process.env.REACT_APP_API_URL + services.deleteBanner;

export const getBanners = (page = 1, limit = 10) => dispatch => {
	const params = {
		is_active: 1,
		sort: 'DESC',
		field_sort: 'created_at',
		limit: limit,
		page: page
	};

	axios
		.post(URL_GET_BANNERS, params)
		.then(res => {
			dispatch({
				type: GET_BANNERS,
				payload: res.data
			})
		})
		.catch(err => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(err)
			})
		});
};

export const createBanner = (skues, url, order, type) => dispatch => {
	var skuesArray = []
	var dataPost = {}
	if (skues) {
		skuesArray = skues.map(sku => sku.sku)
		dataPost.skues = skuesArray
	}
	if (type) {
		dataPost.dataType = type
	}
	if (url) {
		dataPost.url = url
	}
	if (order) {
		dataPost.order = order
	}

	axios
		.post(URL_CREATE_BANNER, dataPost)
		.then(res => {
			dispatch({
				type: CREATE_BANNER,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const updateBanner = (_id, skues, url, order, type) => dispatch => {
	var skuesArray = []
	var dataPost = {}
	dataPost.id = _id
	if (type) {
		dataPost.dataType = type
		if (type === 'INFORMATIVO') {
			dataPost.skues = [];
		} else {
			for (var i = 0; i < skues.length; i++) {
				if (skues[0].sku) {
					var sku = skues[i]
					skuesArray.push(sku.sku)
				} else {
					var skuesA = skues[i]
					skuesArray.push(skuesA)
				}
			}
			dataPost.skues = skuesArray.length > 0 ? skuesArray : []
		}
	}
	if (url) {
		dataPost.url = url
	}
	if (order) {
		dataPost.order = order
	}
	axios
		.patch(URL_UPDATE_BANNER, dataPost)
		.then(res => {
			dispatch({
				type: UPDATE_BANNER,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateBanner = (id) => dispatch => {
	axios
		.delete(URL_DEACTIVATE_BANNER + id)
		.then(res => {
			dispatch({
				type: DEACTIVATE_BANNER,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};